import { useSyncExternalStore } from 'react';

// Один флаг на всё приложение: «страница загрузилась, браузер освободился». После него и при
// переходах внутри сайта — сразу true
let ready = false;
const listeners = new Set<() => void>();
let waiting = false;

const markReady = () => {
  ready = true;
  listeners.forEach((listener) => listener());
};

const waitForLoad = () => {
  if (waiting) return;
  waiting = true;
  const idle = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(markReady, { timeout: 2000 });
    else setTimeout(markReady, 500);
  };
  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle, { once: true });
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  waitForLoad();
  return () => listeners.delete(listener);
};

/**
 * false — в пререндере, при гидратации и пока страница грузится; true — после load и первого
 * простоя браузера. Для тяжёлых сторонних iframe (плеер Rutube, Яндекс Карта): они начинают
 * грузиться, когда собственное содержимое страницы уже на экране и отвечает
 */
export const useAfterLoad = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => ready,
    () => false,
  );
